(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];
  const money = (cents) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(
      cents / 100
    );
  const isPreview = document.documentElement.dataset.preview === 'true';

  const state = {
    cart: { item_count: 0, total_price: 0, items: [] },
  };

  function previewStore() {
    try {
      return JSON.parse(localStorage.getItem('payground-cart') || '{"items":[]}');
    } catch {
      return { items: [] };
    }
  }
  function savePreview(cart) {
    localStorage.setItem('payground-cart', JSON.stringify(cart));
  }

  async function loadCart() {
    if (isPreview) {
      const stored = previewStore();
      const items = stored.items || [];
      state.cart = {
        items,
        item_count: items.reduce((n, i) => n + i.quantity, 0),
        total_price: items.reduce((n, i) => n + i.price * i.quantity, 0),
      };
      return state.cart;
    }
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    state.cart = await res.json();
    return state.cart;
  }

  function renderCounts() {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = String(state.cart.item_count || 0);
    });
    qsa('[data-cart-subtotal]').forEach((el) => {
      el.textContent = money(state.cart.total_price || 0);
    });
    const body = qs('[data-cart-body]');
    if (!body) return;
    if (!state.cart.items?.length) {
      body.innerHTML = '<p class="muted">Cart is empty. Grab a download from the catalog.</p>';
      return;
    }
    body.innerHTML = `<ul class="cart-lines cart-lines--drawer">${state.cart.items
      .map(
        (item) =>
          `<li class="cart-line"><strong>${item.product_title || item.title}</strong><span>${item.quantity} × ${money(
            item.final_price || item.price
          )}</span></li>`
      )
      .join('')}</ul>`;
  }

  function openCart() {
    const drawer = qs('#CartDrawer');
    const backdrop = qs('[data-cart-backdrop]');
    if (!drawer) return;
    drawer.hidden = false;
    if (backdrop) backdrop.hidden = false;
    qsa('[data-cart-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    qs('[data-cart-close]')?.focus();
  }
  function closeCart() {
    const drawer = qs('#CartDrawer');
    const backdrop = qs('[data-cart-backdrop]');
    if (!drawer) return;
    drawer.hidden = true;
    if (backdrop) backdrop.hidden = true;
    qsa('[data-cart-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) {
      const dialog = qs('#SearchDialog');
      if (dialog?.showModal) dialog.showModal();
      qs('#SearchInput')?.focus();
    }
    if (e.target.closest('[data-search-close]')) qs('#SearchDialog')?.close();
    if (e.target.closest('[data-cart-open]')) openCart();
    if (e.target.closest('[data-cart-close]')) closeCart();
    if (e.target.closest('[data-cart-backdrop]')) closeCart();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  async function addItem(payload) {
    if (isPreview) {
      const cart = previewStore();
      const existing = cart.items.find((i) => i.id === payload.id);
      if (existing) existing.quantity += payload.quantity || 1;
      else cart.items.push({ ...payload, quantity: payload.quantity || 1 });
      savePreview(cart);
      await loadCart();
      renderCounts();
      openCart();
      return;
    }
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    await loadCart();
    renderCounts();
    openCart();
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    const buyNow = e.submitter?.hasAttribute('data-buy-now');
    if (buyNow && !isPreview) return;
    e.preventDefault();
    const data = new FormData(form);
    const id = data.get('id');
    const quantity = Number(data.get('quantity') || 1);
    const title = form.dataset.title || document.querySelector('h1')?.textContent?.trim() || 'Download';
    const price = Number(form.dataset.price || 0);
    await addItem({
      id,
      quantity,
      title,
      product_title: title,
      price,
      final_price: price,
    });
    if (buyNow && isPreview) window.location.href = 'cart.html';
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-demo]');
    if (!btn) return;
    const item = JSON.parse(btn.getAttribute('data-add-demo'));
    await addItem(item);
  });

  const boot = () => loadCart().then(renderCounts);
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.PaygroundBoot = boot;
})();
